import React, { useContext } from "react";
import { Link, Outlet } from "react-router-dom";
import "./App.css"; // Asegúrate de que los estilos estén correctamente importados
import { PuaContext } from "./PuaContext"; // Importa el contexto

function Layout() {
  const currentSet = useContext(PuaContext); // Consume el contexto

  return (
    <div className="app-container">
      {}
      <header className="header">
        <h1>Javier Cobalto</h1>
      </header>

      {}
      <nav className="navigation">
        <ul>
          {currentSet.map((item, index) => (
            <li key={index}>
              {item.text === "Home" ? (
                // Usar un enlace <a> para "Home" para forzar una recarga completa
                <a href={item.path} className="nav-link">
                  <img src={item.src} alt={item.text} className="nav-icon" />
                  <span>{item.text}</span>
                </a>
              ) : (
                // Usar <Link> para las demás rutas
                <Link to={item.path} className="nav-link">
                  <img src={item.src} alt={item.text} className="nav-icon" />
                  <span>{item.text}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {}
      <Outlet />

      {}
      <footer className="footer">
        <span>&copy; 2024 Javier Cobalto</span>
        <img src="/images/carlanca.png" alt="Logo de Javier Cobalto" className="footer-logo" />
      </footer>
    </div>
  );
}

export default Layout;